import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { DivisionContext, DivisionContextService } from '@app/core/services/division/division-context.service';
import { SessionService } from '@app/core/services/session/session.service';
import { NotificationService } from '@app/features/notification/services/notification.service';
import { User } from '@app/shared/models/user.interface';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

@Component({
  selector: 'vfs-header-toolbar',
  templateUrl: './header-toolbar.component.html',
  styleUrls: ['./header-toolbar.component.scss']
})
export class HeaderToolbarComponent implements OnInit, OnDestroy {
  @Output() userDropdown = new EventEmitter();
  @Output() divisionDropdown = new EventEmitter();
  @Output() notificationsPanel = new EventEmitter();

  divisionFilter$: Observable<DivisionContext>;
  user$: Observable<User>;
  activeDivisions: boolean;
  numUnreadNotifications$: Observable<number>;

  constructor(
    protected divisionContextService: DivisionContextService,
    protected sessionService: SessionService,
    protected notificationService: NotificationService
  ) {}

  ngOnInit() {
    this.divisionFilter$ = this.divisionContextService
      .getDivisionFilter()
      .pipe(tap(result => (this.activeDivisions = this.checkDivisions(result))));

    this.user$ = this.sessionService.userSubject$;

    this.notificationService.openSocket();
    this.numUnreadNotifications$ = this.notificationService.getNumUnreadNotifications();
  }

  checkDivisions(context: DivisionContext): boolean {
    let filter = context.filter;
    let keys = Object.keys(filter);
    if (keys.length > 0) {
      return keys.filter(key => filter[key].length > 0).length > 0;
    } else {
      return false;
    }
  }

  divisionFilterEnabled() {
    return this.divisionContextService.isGlobalDivisions();
  }

  public getNumUnreadNotifications(value: number): string | number {
    return value > 99 ? '+99' : value;
  }

  ngOnDestroy(): void {
    this.notificationService.closeSocket();
  }
}
